












































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { create } from '@/util/createApi';
@Component({
  components: {},
})
export default class ExplanatoryText extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '123123';
  private drawer = false;

  private form: any = {
    title: '说明文字',
    placeholder: '请输入说明文字',
    placeholder2: '请输入',
  };

  // 选项列表
  private optionsList: any = [];

  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }

  // 添加选项  待完善
  addOption() {
    console.log('add');
  }
}
